export default [
  {
    attr: "name",
    name: "名称",
    value: "",
    type: "Input",
    props: {
      placeholder: "请输入",
      rules: {
        required: true,
        message: "请输入",
        target: "blur",
      },
    },
  },
  {
    attr: 'cover_image_url',
    name: "封面",
    value: "",
    type: "SelectImage",
    props: {
      rules: {
        required: false,
        message: "请选择",
        target: "blur",
      },
    },
    status: "1",
  },
  {
    attr: 'json_config_original',
    value: {
      layout: [
        {},
        {
          type: 0,
          config: [{
            name: "游戏场景",
            value: "",
            type: "SelectGameForm",
            props: {
              rules: {
                required: true,
                message: "请选择",
                target: "blur",
              },
              typeName: "word",
            },
            status: "1",
          }],
        },
        {},
      ],
    },
    type: "YourselfDiy",
    props: {},
    status: "1",
  },
];
